export class OrganizationDto {
  id: number; // TODO: this should be a string!
  name: string;
  type: string;
  description: string;
  no: string;
  level1Id: number;
  /* eslint-disable @typescript-eslint/naming-convention */
  // TODO: check whether API returns Level1Id or level1Id
  Level2Id: number;
  Level3Id: number;
  Level4Id: number;
  Level5Id: number;
  Level6Id: number;
  Level7Id: number;
  Level8Id: number;
  Level9Id: number;
  Level10Id: number;
  /* eslint-enable @typescript-eslint/naming-convention */
  countryCode: string;
  level: number;
  checked: boolean = false;
  hidden: boolean = false;
  enabled: boolean = true;
  editable: boolean = true;
  isIntegrated: boolean = false;
  isInherited: boolean = false;
  childOrganizations: OrganizationDto[] = [];

  public constructor(init?: Partial<OrganizationDto>) {
    Object.assign(this, init);
  }
}
